import { render, staticRenderFns } from "./TrackedMatchIds.vue?vue&type=template&id=23ddccd9"
import script from "./TrackedMatchIds.vue?vue&type=script&lang=js"
export * from "./TrackedMatchIds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports